import { Injectable } from "@angular/core";
import { IIconProperties, ToastTheme } from "@tylertech/forge";
import { ToastService as ForgeToastService } from '@tylertech/forge-angular';

@Injectable()
export class ToastService
{
    constructor(
        private readonly toastService: ForgeToastService
    ) { }

    public showActionableToast(message: string, actionText: string, handler: ()=> void, duration: number = 6000, theme: ToastTheme = "secondary"): void
    {
        this.toastService.show({ message: message, duration: duration, actionText: actionText, actionHandler: handler, theme: theme});
    }

    public showToast(message: string, duration: number = 6000, theme: ToastTheme = "secondary"): void
    {
        this.show(message, duration, theme);
    }

    public showToastPromise(message: string, duration: number = 6000, theme: ToastTheme = "secondary"): Promise<void>
    {
        this.show(message, duration, theme);
        return new Promise(x => setTimeout(x, duration));
    }

    private show(message: string, duration: number = 6000, theme: ToastTheme, actionText: string = null, handler?: ()=> void): void
    {
        let icon: IIconProperties = null;
        if(theme === "error" || theme === "warning")
        {
            icon = {name: theme, src: undefined, lazy: false, external: false, externalUrlBuilder: null, theme: null, viewbox: "", externalType: null};
        }
        this.toastService.show({ message: message, duration: duration, actionText: actionText, actionHandler: handler, theme: theme, icon: icon});
    }
}
